<template>
  <main class="c-pagedesigner page-designer-reference main-content main-content--mobile page" id="main-content" style="padding-top: 0px">
    <div class="col-12 px-2 c-strat__container">
      <div class="experience-component experience-layouts-1column">
        <div style="">
          <div class="experience-region experience-column1">
            <div class="experience-component experience-assets-strat2">
              <div class="c-strat2 c-background js_strat layout layout--full-width" style="">
                <div class="c-strat2__main-image c-background__content-wrapper js_strat_main_image null">
                  <div class="layout">
                    <div class="c-background__content">
                      <div class="ms-row center-xs">
                        <div class="col-xs-10 col-md-6">
                          <div class="c-strat2__title-wrapper">
                            <span class="c-strat2__title" style="color: null">
                              <h2><span style="color: rgb(0, 0, 0)">艺术与创作</span></h2>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="ms-row center-xs">
                        <div class="col-xs-12">
                          <div class="c-strat2__image-wrapper">
                            <img class="lazyloaded" alt="" src="@/assets/imgs/CMS-pages/art-creation/visuel1.jpg" />
                          </div>
                        </div>
                      </div>
                      <div class="ms-row center-xs full-width">
                        <div class="col-xs-10 col-md-8">
                          <div class="c-strat2__title-wrapper-bottom">
                            <div class="c-strat2__big-p" style="color: null">
                              <p><span style="color: rgb(0, 0, 0)">「美是造物者的旨意，意味着生命拥有意义。」François Cheng</span></p>
                            </div>
                            <div class="c-strat2__regular-p" style="color: null">
                              <p><span style="color: rgb(0, 0, 0)">作为热忱的艺术爱好者兼收藏家，伊莎贝尔和修伯特·诺纳诺伯爵夫妇自品牌创立之初，便与他们欣赏的艺术家携手合作。</span></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="experience-component experience-layouts-strat3">
        <div style="background-color: #f8f4f1">
          <div class="layout c-strat3">
            <div class="ms-row center-xs">
              <div class="col-xs-12 col-sm-11 col-md-8">
                <div class="c-strat3__title-wrapper">
                  <div class="c-strat3__subtitle" style="color: null">
                    <p><span style="color: rgb(0, 0, 0)">波兰雕塑家Bronislaw Krzysztof在与伊莎贝尔·多纳诺在巴黎共进午餐之后，深受启发，为她创作了十座金属雕像。</span></p>
                  </div>
                </div>
              </div>
            </div>
            <div class="ms-row center-xs">
              <div class="col-xs-12 col-sm-11 col-md-8">
                <div class="experience-component experience-assets-imagetextstrat3">
                  <div class="c-img-start3 layout c-pd-video c-img-start3--extended">
                    <img class="lazyloaded" alt="La famille d'Ornano est passionnée d'art." src="@/assets/imgs/CMS-pages/art-creation/visuel22-hk.jpg" />
                    <div class="c-img-start3--text-wrapper">
                      <div class="c-img-start3__img-subtitle" style="color: null">
                        <p>
                          其中两座雕塑随后成为
                          <a data-product-id="100155" data-link-label="100155" data-link-type="product" target="_self" href="/detail?id=357">Soir de Lune</a>
                          和
                          <a data-product-id="100153" data-link-label="100153" data-link-type="product" target="_self" href="/detail?id=353">Eau du Soir</a>香水瓶的造型。
                        </p>
                      </div>
                    </div>
                    <div class="ms-row center-xs">
                      <div class="col-xs-12 col-sm-10 col-md-9"></div>
                    </div>
                  </div>
                </div>
                <div class="experience-component experience-assets-imagetextstrat3">
                  <div class="c-img-start3 layout c-pd-video c-img-start3--extended">
                    <img class="lazyloaded" src="@/assets/imgs/CMS-pages/art-creation/visuel3.gif" alt="" />
                    <div class="c-img-start3--text-wrapper"></div>
                    <div class="ms-row center-xs">
                      <div class="col-xs-12 col-sm-10 col-md-9"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="experience-component experience-layouts-strat3">
        <div style="">
          <div class="layout c-strat3">
            <div class="ms-row center-xs"></div>
            <div class="ms-row center-xs">
              <div class="col-xs-12 col-sm-11 col-md-8">
                <div class="experience-component experience-assets-imagetextstrat3">
                  <div class="c-img-start3 layout c-pd-video c-img-start3--extended">
                    <img class="lazyloaded" src="@/assets/imgs/CMS-pages/art-creation/visuel4a-hk.jpg" alt="Colorée" />
                    <div class="c-img-start3--text-wrapper">
                      <div class="c-img-start3__img-subtitle" style="color: null">
                        <p><span style="color: rgb(0, 0, 0)">画家Elzbieta Radziwill不仅为多家Maison Sisley精品店的室内装潢带来了美轮美奂的设计，还负责设计了Eau Tropicale香水瓶造型及Ecological Compound 2018年和2019年限量版的包装。</span></p>
                      </div>
                    </div>
                    <div class="ms-row center-xs">
                      <div class="col-xs-12 col-sm-10 col-md-9"></div>
                    </div>
                  </div>
                </div>
                <div class="experience-component experience-assets-imagetextstrat3">
                  <div class="c-img-start3 layout c-pd-video c-img-start3--extended">
                    <img class="lazyloaded" src="@/assets/imgs/CMS-pages/art-creation/visuel4-hk.jpg" alt="Romantisme" />
                    <div class="c-img-start3--text-wrapper">
                      <div class="c-img-start3__img-subtitle" style="color: null">
                        <p><span style="color: rgb(0, 0, 0)">当Izia香水于2017年问世时，Sisley又与英国插画师Quentin Jones合作，透过这位艺术家的美妙创意为此款香氛注入新生。他将玫瑰、伊莎贝尔·多纳诺设计的刺绣图案和街头艺术、印刷字体融为一体，拼贴出一个洋溢着浪漫气息的美妙组合。</span></p>
                      </div>
                    </div>
                    <div class="ms-row center-xs">
                      <div class="col-xs-12 col-sm-10 col-md-9"></div>
                    </div>
                  </div>
                </div>
                <div class="experience-component experience-assets-imagetextstrat3">
                  <div class="c-img-start3 layout c-pd-video c-img-start3--extended">
                    <img class="lazyloaded" src="@/assets/imgs/CMS-pages/art-creation/visuel5.jpg" alt="Izia - Sisley Paris" />
                    <div class="c-img-start3--text-wrapper"></div>
                    <div class="ms-row center-xs">
                      <div class="col-xs-12 col-sm-10 col-md-9"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="experience-component experience-layouts-strat1">
        <div class="c-strat1 js_strat c-background layout layout--full-width c-strat1--image" style="">
          <div class="c-strat1__background js_strat_background c-background__image-container">
            <img class="show-for-md c-background__image js-image--large" src="@/assets/imgs/CMS-pages/art-creation/background1.jpg" />
            <img class="hide-for-md c-background__image js-image--small" src="@/assets/imgs/CMS-pages/art-creation/background1-mobile.jpg" />
          </div>
          <div class="c-strat1__main-image c-background__content-wrapper js_strat_main_image has-image" style="min-height: 0px">
            <div class="layout">
              <div class="ms-row c-background__content"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="experience-component experience-layouts-1column">
        <div style="">
          <div class="experience-region experience-column1"></div>
        </div>
      </div>
      <div class="experience-component experience-layouts-strat3">
        <div style="background-color: #f8f4f1">
          <div class="layout c-strat3">
            <div class="ms-row center-xs">
              <div class="col-xs-12 col-sm-11 col-md-8">
                <div class="c-strat3__title-wrapper">
                  <div class="c-strat3__subtitle" style="color: null">
                    <p><span style="color: rgb(0, 0, 0)">艺术合作</span></p>
                  </div>
                </div>
              </div>
            </div>
            <div class="ms-row center-xs">
              <div class="col-xs-12 col-sm-11 col-md-8">
                <div class="experience-component experience-assets-imagetextstrat3">
                  <div class="c-img-start3 layout c-pd-video c-img-start3--extended">
                    <img class="lazyloaded" src="@/assets/imgs/CMS-pages/art-creation/visuel6.jpg" alt="Elzbieta Radziwill用感性的艺术作品和精美的家具粉饰Maison Sisley的室内空间。" />
                    <div class="c-img-start3--text-wrapper">
                      <div class="c-img-start3__img-subtitle" style="color: null">
                        <h2><strong style="color: rgb(0, 0, 0)">SISLEY X Elzbieta Radziwill</strong></h2>
                      </div>
                    </div>
                    <div class="ms-row center-xs">
                      <div class="col-xs-12 col-sm-10 col-md-9">
                        <div class="c-strat3__small-p" style="color: null">
                          <p><span style="color: rgb(0, 0, 0)">这位波兰艺术家通过色彩和梦幻的想象力构思出一个充满魔力的世界：在这个神奇的天地，大自然与动物和谐共存。过往的旅行、邂逅的人物和各地的传统为她提供了源源不断的创作灵感。</span></p>
                          <p><span style="color: rgb(0, 0, 0)">Elzbieta Radziwill用诗意盎然的动物绘画和家具，装饰Maison Sisley的内部空间。她还绘制了Eau Tropicale香水的插画及2018年和2019年限量版全能乳液的包装。</span></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="experience-component experience-layouts-strat3">
        <div style="background-color: #f6f4f1">
          <div class="layout c-strat3">
            <div class="ms-row center-xs"></div>
            <div class="ms-row center-xs">
              <div class="col-xs-12 col-sm-11 col-md-8">
                <div class="experience-component experience-assets-imagetextstrat3">
                  <div class="c-img-start3 layout c-pd-video c-img-start3--extended">
                    <img class="lazyloaded" src="@/assets/imgs/CMS-pages/art-creation/visuel7.jpg" alt="艺术家Sydney Albertini为限量版夜幽香水带来如渲染天空般的梦幻视觉" />
                    <div class="c-img-start3--text-wrapper">
                      <div class="c-img-start3__img-subtitle" style="color: null">
                        <h2><strong style="color: rgb(0, 0, 0)">SISLEY X Sydney Albertini</strong></h2>
                      </div>
                    </div>
                    <div class="ms-row center-xs">
                      <div class="col-xs-12 col-sm-10 col-md-9">
                        <div class="c-strat3__small-p" style="color: null">
                          <p><span style="color: rgb(0, 0, 0)">Sydney Albertini是一位生活在纽约的巴黎艺术家，不仅以绘画和雕塑而闻名，还擅长针织、陶瓷和编织创作。在过去一年间，她每天清晨起床都会在iPad上绘制一幅天空的图画。</span></p>
                          <p><span style="color: rgb(0, 0, 0)">在与Sisley合作的过程中，她用清澈的天蓝色和纯净的粉色构成一个如梦似幻的天空，并以此来点缀夜幽香水的标志性瓶身，「Skies」限量版香水由此问世。</span></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="experience-component experience-layouts-strat3">
        <div style="background-color: #f6f4f1">
          <div class="layout c-strat3">
            <div class="ms-row center-xs"></div>
            <div class="ms-row center-xs">
              <div class="col-xs-12 col-sm-11 col-md-8">
                <div class="experience-component experience-assets-imagetextstrat3">
                  <div class="c-img-start3 layout c-pd-video c-img-start3--extended">
                    <img class="lazyloaded" src="@/assets/imgs/CMS-pages/art-creation/visuel8.jpg" alt="波兰艺术家Edyta Klaper为Sisley的节日香氛礼盒绘制插画。" />
                    <div class="c-img-start3--text-wrapper">
                      <div class="c-img-start3__img-subtitle" style="color: null">
                        <h2><strong style="color: rgb(34, 34, 34)">SISLEY X Edyta Klaper</strong></h2>
                      </div>
                    </div>
                    <div class="ms-row center-xs">
                      <div class="col-xs-12 col-sm-10 col-md-9">
                        <div class="c-strat3__small-p" style="color: null">
                          <p><span style="color: rgb(0, 0, 0)">来自波兰罗兹美术学院的Edyta Klaper是一名杰出的学子。她绘制的作品被Sisley选中在Trois Cinq Friedland展出。</span></p>
                          <p><span style="color: rgb(0, 0, 0)">随后，品牌又邀请她设计2020年节日限定版香水礼盒包装。她以伊莎贝尔多纳诺的个人世界为设计灵感，构思出四种狂野而丰茂的自然景色，植物焕发勃勃生机，迸发出鲜艳的色彩。Klaper还为Sisleÿa系列的视觉设计打造了全新的艺术风貌。</span></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="experience-component experience-layouts-strat1">
        <div class="c-strat1 js_strat c-background layout layout--full-width c-strat1--image" style="">
          <div class="c-strat1__background js_strat_background c-background__image-container">
            <img class="show-for-md c-background__image js-image--large" src="@/assets/imgs/CMS-pages/art-creation/background2.png" />
            <img class="hide-for-md c-background__image js-image--small" src="@/assets/imgs/CMS-pages/art-creation/background2-mobile.jpg" />
          </div>
          <div class="c-strat1__main-image c-background__content-wrapper js_strat_main_image has-image" style="min-height: 0px">
            <div class="layout">
              <div class="ms-row c-background__content"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="experience-component experience-layouts-strat1">
        <div class="c-strat1 js_strat c-background layout layout--full-width null" style="">
          <div class="c-strat1__main-image c-background__content-wrapper js_strat_main_image no-image">
            <div class="layout">
              <div class="ms-row row-with-template c-background__content"></div>
              <div class="c-strat1--template-wrapper">
                <div class="ms-row c-strat1--rowB">
                  <div class="col-xs-12 col-sm-6 col-md-4 strat-col c-strat1--col">
                    <div class="experience-component experience-assets-imagetextstrat1">
                      <div class="c-img-start1 layout c-pd-video">
                        <div class="ms-row center-xs wrapper-img">
                          <div class="col-xs-12 c-img-start1__elements">
                            <div class="c-img-start1__title-wrapper">
                              <h2 class="c-img-start1--title text--left" style="color: null">Isabelle d'Ornano</h2>
                            </div>
                            <div class="c-img-start1__imagevideo-wrapper">
                              <div class="pd-lazyvimeoframe" data-width="389" data-height="544">
                                <div class="c-lazy-frame">
                                  <div class="c-lazy-frame__vimeo pd-lazyvimeoframe-values" data-embed="451157723" data-light-version="null" style="padding-bottom: 139.846%">
                                    <VideoStatic :canPlay="canPlay" @changePlay='changePlay' :ref="videoSrc.Isabelle_d_Ornano" :vSrc="videoSrc.Isabelle_d_Ornano"  :iSrc_m="videoSrc.I970203809_1200" :isAuto="false" :isLoop="true" :showControls="true" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-4 strat-col c-strat1--col">
                    <div class="experience-component experience-assets-imagetextstrat1">
                      <div class="c-img-start1 layout c-pd-video">
                        <div class="ms-row center-xs wrapper-img">
                          <div class="col-xs-12 c-img-start1__elements">
                            <div class="c-img-start1__title-wrapper">
                              <h2 class="c-img-start1--title text--left" style="color: null">Elzbieta Radziwill</h2>
                            </div>
                            <div class="c-img-start1__imagevideo-wrapper">
                              <div class="pd-lazyvimeoframe" data-width="389" data-height="544">
                                <div class="c-lazy-frame">
                                  <div class="c-lazy-frame__vimeo pd-lazyvimeoframe-values" data-embed="451162066" data-light-version="null" style="padding-bottom: 139.846%">
                                    <VideoStatic :canPlay="canPlay" @changePlay='changePlay' :ref="videoSrc.Elzbieta_Radziwill" :vSrc="videoSrc.Elzbieta_Radziwill"  :iSrc_m="videoSrc.I970205203_1200" :isAuto="false" :isLoop="true" :showControls="true" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-4 strat-col c-strat1--col">
                    <div class="experience-component experience-assets-imagetextstrat1">
                      <div class="c-img-start1 layout c-pd-video">
                        <div class="ms-row center-xs wrapper-img">
                          <div class="col-xs-12 c-img-start1__elements">
                            <div class="c-img-start1__title-wrapper">
                              <h2 class="c-img-start1--title text--left" style="color: null">Christine d'Ornano</h2>
                            </div>
                            <div class="c-img-start1__imagevideo-wrapper">
                              <div class="pd-lazyvimeoframe" data-width="389" data-height="544">
                                <div class="c-lazy-frame">
                                  <div class="c-lazy-frame__vimeo pd-lazyvimeoframe-values" data-embed="451163805" data-light-version="null" style="padding-bottom: 139.846%">
                                    <VideoStatic :canPlay="canPlay" @changePlay='changePlay' :ref="videoSrc.Christine_d_Ornano" :vSrc="videoSrc.Christine_d_Ornano"  :iSrc_m="videoSrc.I970203636_1200" :isAuto="false" :isLoop="true" :showControls="true" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ms-row c-strat1--rowB--last">
                  <div class="col-xs-12 col-sm-6 col-md-4 strat-col c-strat1--col">
                    <div class="experience-component experience-assets-imagetextstrat1">
                      <div class="c-img-start1 layout c-pd-video">
                        <div class="ms-row center-xs wrapper-img">
                          <div class="col-xs-12 c-img-start1__elements">
                            <div class="c-img-start1__title-wrapper">
                              <h2 class="c-img-start1--title text--left" style="color: null">Andréa Zarraluqui</h2>
                            </div>
                            <div class="c-img-start1__imagevideo-wrapper">
                              <div class="pd-lazyvimeoframe" data-width="389" data-height="544">
                                <div class="c-lazy-frame">
                                  <div class="c-lazy-frame__vimeo pd-lazyvimeoframe-values" data-embed="451407869" data-light-version="null" style="padding-bottom: 139.846%">
                                    <VideoStatic :canPlay="canPlay" @changePlay='changePlay' :ref="videoSrc.Andréa_Zarraluqui" :vSrc="videoSrc.Andréa_Zarraluqui"  :iSrc_m="videoSrc.I970204397_1200" :isAuto="false" :isLoop="true" :showControls="true" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-4 strat-col c-strat1--col">
                    <div class="experience-component experience-assets-imagetextstrat1">
                      <div class="c-img-start1 layout c-pd-video">
                        <div class="ms-row center-xs wrapper-img">
                          <div class="col-xs-12 c-img-start1__elements">
                            <div class="c-img-start1__title-wrapper">
                              <h2 class="c-img-start1--title text--left" style="color: null">Bronislaw Krzysztof</h2>
                            </div>
                            <div class="c-img-start1__imagevideo-wrapper">
                              <div class="pd-lazyvimeoframe" data-width="389" data-height="544">
                                <div class="c-lazy-frame">
                                  <div class="c-lazy-frame__vimeo pd-lazyvimeoframe-values" data-embed="451427393" data-light-version="null" style="padding-bottom: 139.846%">
                                    <VideoStatic :canPlay="canPlay" @changePlay='changePlay' :ref="videoSrc.Bronislaw_Krzysztof" :vSrc="videoSrc.Bronislaw_Krzysztof"  :iSrc_m="videoSrc.I970204987_1200" :isAuto="false" :isLoop="true" :showControls="true" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-4 strat-col c-strat1--col">
                    <div class="experience-component experience-assets-imagetextstrat1">
                      <div class="c-img-start1 layout c-pd-video">
                        <div class="ms-row center-xs wrapper-img">
                          <div class="col-xs-12 c-img-start1__elements">
                            <div class="c-img-start1__title-wrapper">
                              <h2 class="c-img-start1--title text--left" style="color: null">Elisabeth d'Ornano</h2>
                            </div>
                            <div class="c-img-start1__imagevideo-wrapper">
                              <div class="pd-lazyvimeoframe" data-width="389" data-height="544">
                                <div class="c-lazy-frame">
                                  <div class="c-lazy-frame__vimeo pd-lazyvimeoframe-values" data-embed="451431171" data-light-version="null" style="padding-bottom: 139.846%">
                                    <VideoStatic :canPlay="canPlay" @changePlay='changePlay' :ref="videoSrc.Elisabeth_d_Ornano" :vSrc="videoSrc.Elisabeth_d_Ornano"  :iSrc_m="videoSrc.I970204845_1200" :isAuto="false" :isLoop="true" :showControls="true" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="experience-component experience-layouts-2column">
        <div class="c-pagedesigner__module-space c-pagedesigner__module-space-background" style="background-color: #f9f9f9">
          <div class="layout">
            <div class="ms-row center-xs">
              <div class="col-xs-12 col-md-8 col-lg-6">
                <div class="c-pagedesigner__title-wrapper">
                  <h3 class="c-pagedesigner__title heading-h3 text--center c-pagedesigner__text-content">探索更多</h3>
                </div>
              </div>
            </div>
          </div>
          <div class="layout">
            <div class="ms-row center-xs">
              <div class="col-xs-12 col-sm-6">
                <div class="experience-component experience-assets-editorialpush">
                  <div class="c-editorial-push c-content-carousel__item">
                    <a href="/foundation" class="c-text-image c-text-image–-secondary">
                      <div class="c-text-image__visual">
                        <img class="lazyloaded" src="@/assets/imgs/CMS-pages/art-creation/rebond-fondation.jpg" alt="" />
                        <div class="c-text-image__visual-title c-text-image__visual-title--thin">
                          <div class="c-text-image__visual-title--uppercase">关于基金会</div>
                          Sisley-d'Ornano
                        </div>
                      </div>
                      <div class="c-text-image__content start-xs">
                        <div class="c-text-image__text">
                          <div class="c-text-image__description">用行动支持改变</div>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6">
                <div class="experience-component experience-assets-editorialpush">
                  <div class="c-editorial-push c-content-carousel__item">
                    <a href="/entreprise" class="c-text-image c-text-image–-secondary">
                      <div class="c-text-image__visual">
                        <img class="lazyloaded" src="@/assets/imgs/CMS-pages/expertise-sisley/rebond-entreprise.jpg" alt="" />
                        <div class="c-text-image__visual-title c-text-image__visual-title--thin">
                          <div class="c-text-image__visual-title--uppercase">关于公司</div>
                          Sisley
                        </div>
                      </div>
                      <div class="c-text-image__content start-xs">
                        <div class="c-text-image__text">
                          <div class="c-text-image__description">敢于创新的法国家族企业</div>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="experience-component experience-layouts-1column">
        <div style="">
          <div class="experience-region experience-column1">
            <div class="experience-component experience-assets-topCategoryPD">
              <div class="js-pagedesigner-id sr-only" data-pd-id="art-creation"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import Isabelle_d_Ornano from '../../assets/imgs/CMS-pages/art-creation/Isabelle_d_Ornano.mp4'
import Bronislaw_Krzysztof from '../../assets/imgs/CMS-pages/art-creation/Bronislaw_Krzysztof.mp4'
import Christine_d_Ornano from '../../assets/imgs/CMS-pages/art-creation/Christine_d_Ornano.mp4'
import Elisabeth_d_Ornano from '../../assets/imgs/CMS-pages/art-creation/Elisabeth_d_Ornano.mp4'
import Elzbieta_Radziwill from '../../assets/imgs/CMS-pages/art-creation/Elzbieta_Radziwill.mp4'
import Andréa_Zarraluqui from '../../assets/imgs/CMS-pages/art-creation/Andréa_Zarraluqui.mp4'
import I970203809_1200 from '../../assets/imgs/CMS-pages/art-creation/970203809_1200.jpg'
import I970205203_1200 from '../../assets/imgs/CMS-pages/art-creation/970205203_1200.jpg'
import I970203636_1200 from '../../assets/imgs/CMS-pages/art-creation/970203636_1200.jpg'
import I970204397_1200 from '../../assets/imgs/CMS-pages/art-creation/970204397_1200.jpg'
import I970204987_1200 from '../../assets/imgs/CMS-pages/art-creation/970204987_1200.jpg'
import I970204845_1200 from '../../assets/imgs/CMS-pages/art-creation/970204845_1200.jpg'

import VideoStatic from '@/components/VideoStatic';
export default {
  name: "ArtCreation",
  components: { VideoStatic },
  data() {
    return {
      showSrc: true,
      videoSrc: {
        Isabelle_d_Ornano,
        Bronislaw_Krzysztof,
        Christine_d_Ornano,
        Elisabeth_d_Ornano,
        Elzbieta_Radziwill,
        Andréa_Zarraluqui,
        I970203809_1200,
        I970205203_1200,
        I970203636_1200,
        I970204397_1200,
        I970204987_1200,
        I970204845_1200
      },
      canPlay: false
    }
  },
  mounted() {
      setTimeout(()=>{
        this.initElements()
      },2000)
  },
  methods: {
    toPlay() {
      this.showSrc = false
    },
    changePlay(data) {
      let vElement1 = this.$refs[this.videoSrc.Isabelle_d_Ornano]
      let vElement2 = this.$refs[this.videoSrc.Bronislaw_Krzysztof]
      let vElement3 = this.$refs[this.videoSrc.Christine_d_Ornano]
      let vElement4 = this.$refs[this.videoSrc.Elisabeth_d_Ornano]
      let vElement5 = this.$refs[this.videoSrc.Elzbieta_Radziwill]
      let vElement6 = this.$refs[this.videoSrc.Andréa_Zarraluqui]
      let elementArr = [vElement1, vElement2, vElement3, vElement4, vElement5, vElement6]
      elementArr.forEach(item => {
        if(item.vSrc != data.vSrc) item.toPuase()
      })
    },
    initElements() {
      Array.from(document.querySelectorAll(".js_strat_main_image")).forEach(dom => {
        let bgImgSelector = "", extraHeight = 0;
        if (window.innerWidth >= 1024) {
          bgImgSelector = ".js-image--large";
        } else {
          bgImgSelector = ".js-image--small";
          extraHeight = 150;
        }
        let bgImg = dom.parentElement.querySelector(bgImgSelector)
        bgImg && dom.style.setProperty("min-height", bgImg.getBoundingClientRect().height - extraHeight + "px");
      });
    },
  }
};
</script>

<style lang="css" scoped>
.page{position:relative;overflow-x:hidden}
@media screen and (min-width:64em){.page{overflow:hidden}}
.hidden{display:none}
html{font-family:sans-serif;line-height:1.15;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}
article,aside,footer,header,nav,section{display:block}
h1{font-size:2em;margin:.67em 0}
figcaption,figure,main{display:block}
figure{margin:1em 40px}
hr{box-sizing:content-box;height:0;overflow:visible}
pre{font-family:monospace,monospace;font-size:1em}
a{background-color:transparent;-webkit-text-decoration-skip:objects}
a:active,a:hover{outline-width:0}
abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}
b,strong{font-weight:inherit;font-weight:bolder}
code,kbd,samp{font-family:monospace,monospace;font-size:1em}
dfn{font-style:italic}
mark{background-color:#ff0;color:#000}
sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}
sub{bottom:-.25em}
sup{top:-.5em}
audio,video{display:inline-block}
audio:not([controls]){display:none;height:0}
img{border-style:none}
svg:not(:root){overflow:hidden}
button,input,optgroup,select,textarea{font-family:sans-serif;font-size:100%;line-height:1.15;margin:0}
button,input{overflow:visible}
button,select{text-transform:none}
[type=reset],[type=submit],button,html [type=button]{-webkit-appearance:button}
[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{border-style:none;padding:0}
[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring,button:-moz-focusring{outline:1px dotted ButtonText}
fieldset{border:1px solid silver;margin:0 2px;padding:.35em .625em .75em}
legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}
progress{display:inline-block;vertical-align:baseline}
textarea{overflow:auto}
[type=checkbox],[type=radio]{box-sizing:border-box;padding:0}
[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}
[type=search]{-webkit-appearance:textfield;outline-offset:-2px}
[type=search]::-webkit-search-cancel-button,[type=search]::-webkit-search-decoration{-webkit-appearance:none}
::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}
details,menu{display:block}
summary{display:list-item}
canvas{display:inline-block}
[hidden],template{display:none}
blockquote,dd,div,dl,dt,form,h1,h2,h3,h4,h5,h6,li,ol,p,pre,td,th,ul{margin:0;padding:0}
em,i{font-style:italic}
b,em,i,strong{line-height:inherit}
b,strong{font-weight:700}
small{font-size:80%;line-height:inherit}
address{font-style:normal}
dl,ol,ul{line-height:1.6;margin-bottom:1rem;list-style-position:outside}
li{font-size:inherit}
ul{list-style-type:none}
ol,ul{margin-left:0}
ol ol,ol ul,ul ol,ul ul{margin-left:0;margin-bottom:0}
p{font-size:inherit;line-height:1.6;margin-bottom:1rem;text-rendering:optimizeLegibility}
.heading-h1,.heading-h2,.heading-h3,.heading-h4,.heading-h5,.heading-h6,h1,h2,h3,h4,h5,h6{color:#000;margin-top:0;margin-bottom:.5rem}
.heading-h1,h1{font-family:HelveticaNeueLTW05-35Thin,arial,sans-serif;font-weight:400;font-style:normal;line-height:1.16}
.heading-h2,.heading-h4,.heading-h6,h2,h4,h6{font-family:HelveticaNeueLTW05-45Light,arial,sans-serif;font-weight:400;font-style:normal}
.heading-h3,h3{text-transform:uppercase;letter-spacing:.0625rem;display:block}
.heading-h3,.heading-h5,h3,h5{font-family:HelveticaNeueLTW05-75Bold,arial,sans-serif;font-weight:400;font-style:normal;line-height:1.66}
.heading-h5,h5{letter-spacing:normal}
.heading-h2,h2{line-height:1.32}
.heading-h4,.heading-h6,h4,h6{line-height:1.5}
.heading-h1,.heading-h2,h1,h2{font-size:1.5625rem}
.heading-h3,h3{font-size:.75rem}
.heading-h4,h4{font-size:1rem}
.heading-h5,h5{font-size:.75rem}
.heading-h6,h6{font-size:.875rem}
@media screen and (min-width:48em){.heading-h1,h1{font-size:2.1875rem}.heading-h2,h2{font-size:1.5625rem}.heading-h3,h3{font-size:.75rem}.heading-h4,h4{font-size:1rem}.heading-h5,h5{font-size:.75rem}.heading-h6,h6{font-size:.875rem}}
@media screen and (min-width:64em){.heading-h1,h1{font-size:3.125rem}.heading-h2,h2{font-size:1.5625rem}.heading-h3,h3{font-size:.75rem}.heading-h4,h4{font-size:1rem}.heading-h5,h5{font-size:.75rem}.heading-h6,h6{font-size:.875rem}}
.link,a{color:#000;font-family:HelveticaNeueLTW05-75Bold,arial,sans-serif;font-size:.75rem;text-decoration:underline;line-height:inherit;cursor:pointer}
.link:focus,a:focus{text-decoration:none}
@media screen and (min-width:75em){.link:hover,a:hover{text-decoration:none}}
.link img,a img{border:0}
html{font-size:100%;box-sizing:border-box}
@media screen and (min-width:64em){html{overflow-x:hidden}}
*,:after,:before{box-sizing:inherit}
body{padding:0;margin:0;font-family:HelveticaNeueLTW05-45Light,arial,sans-serif;font-weight:400;line-height:1.6;font-size:.8125rem;color:#575757;background:#fff;overflow-x:hidden;opacity:1;transition:opacity 1s;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}
body.fade-out{opacity:0;transition:none}
body:not(.popin-open):not(.no-scroll):not(.js-no-scroll){-webkit-overflow-scrolling:touch}
body.no-scroll-sticky{-webkit-overflow-scrolling:initial!important}
body.mouse-clicked a:focus,body.mouse-clicked a:focus-within,body.mouse-clicked area:focus,body.mouse-clicked area:focus-within,body.mouse-clicked button:focus,body.mouse-clicked button:focus-within,body.mouse-clicked div:focus,body.mouse-clicked div:focus-within,body.mouse-clicked iframe:focus,body.mouse-clicked iframe:focus-within,body.mouse-clicked input:focus,body.mouse-clicked input:focus-within,body.mouse-clicked select:focus,body.mouse-clicked select:focus-within,body.mouse-clicked textarea:focus,body.mouse-clicked textarea:focus-within{outline:none!important;outline-width:0!important;box-shadow:none!important;-moz-box-shadow:none!important;-webkit-box-shadow:none!important}
body.mouse-clicked a:after,body.mouse-clicked a:before,body.mouse-clicked area:after,body.mouse-clicked area:before,body.mouse-clicked button:after,body.mouse-clicked button:before,body.mouse-clicked div:after,body.mouse-clicked div:before,body.mouse-clicked iframe:after,body.mouse-clicked iframe:before,body.mouse-clicked input:after,body.mouse-clicked input:before,body.mouse-clicked select:after,body.mouse-clicked select:before,body.mouse-clicked textarea:after,body.mouse-clicked textarea:before{outline-color:transparent!important}
.text--bold{font-family:HelveticaNeueLTW05-75Bold,arial,sans-serif}
fieldset{border:0;padding:0;margin:0}
textarea{height:auto;min-height:50px}
select{width:100%;z-index:1!important}
button{-webkit-appearance:none;-moz-appearance:none;background:transparent;padding:0;border:0;border-radius:0;line-height:1}
input::-webkit-credentials-auto-fill-button{visibility:hidden;display:none;pointer-events:none;position:absolute;right:0}
form{position:relative}
.disabled{pointer-events:none}
img{-ms-interpolation-mode:bicubic;display:inline-block;vertical-align:middle}
img,object,video{max-width:100%;height:auto}
video::-webkit-media-controls-start-playback-button{display:none}
.lazyload{opacity:0}
.lazyloading{opacity:.25;transition:opacity .2s}
.lazyloaded{opacity:1;transition:opacity .2s}
.image--full-width{width:100%}
.image--contain{object-fit:contain;object-position:center}
.image--fit{object-fit:cover;object-position:center;height:100%;width:100%}
@media (-ms-high-contrast:active),(-ms-high-contrast:none){.image--fit{position:absolute;width:100%;height:auto;top:0;left:50%;transform:translate(-50%)}
}.image--no-max-width{max-width:none}
@media screen and (min-width:64em){.image--auto-width-md{max-width:none;width:auto}
}.container,.container-fluid{margin-right:auto;margin-left:auto}
.container{width:100%;max-width:75rem}
.container-fluid{padding-right:2rem;padding-left:2rem}
.col.reverse{-webkit-box-orient:vertical;-webkit-box-direction:reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse}
.flex-column{flex-direction:column}
.col-xs,.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12,.col-xs-offset-0,.col-xs-offset-1,.col-xs-offset-2,.col-xs-offset-3,.col-xs-offset-4,.col-xs-offset-5,.col-xs-offset-6,.col-xs-offset-7,.col-xs-offset-8,.col-xs-offset-9,.col-xs-offset-10,.col-xs-offset-11,.col-xs-offset-12{box-sizing:border-box;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;padding-right:.625rem;padding-left:.625rem}
.col-xs{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-preferred-size:0;flex-basis:0;max-width:100%}
.col-xs-1{-ms-flex-preferred-size:8.33333333%;flex-basis:8.33333333%;max-width:8.33333333%}
.col-xs-2{-ms-flex-preferred-size:16.66666667%;flex-basis:16.66666667%;max-width:16.66666667%}
.col-xs-3{-ms-flex-preferred-size:25%;flex-basis:25%;max-width:25%}
.col-xs-4{-ms-flex-preferred-size:33.33333333%;flex-basis:33.33333333%;max-width:33.33333333%}
.col-xs-5{-ms-flex-preferred-size:41.66666667%;flex-basis:41.66666667%;max-width:41.66666667%}
.col-xs-6{-ms-flex-preferred-size:50%;flex-basis:50%;max-width:50%}
.col-xs-7{-ms-flex-preferred-size:58.33333333%;flex-basis:58.33333333%;max-width:58.33333333%}
.col-xs-8{-ms-flex-preferred-size:66.66666667%;flex-basis:66.66666667%;max-width:66.66666667%}
.col-xs-9{-ms-flex-preferred-size:75%;flex-basis:75%;max-width:75%}
.col-xs-10{-ms-flex-preferred-size:83.33333333%;flex-basis:83.33333333%;max-width:83.33333333%}
.col-xs-11{-ms-flex-preferred-size:91.66666667%;flex-basis:91.66666667%;max-width:91.66666667%}
.col-xs-12{-ms-flex-preferred-size:100%;flex-basis:100%;max-width:100%}
.col-xs-offset-0{margin-left:0}
.col-xs-offset-1{margin-left:8.33333333%}
.col-xs-offset-2{margin-left:16.66666667%}
.col-xs-offset-3{margin-left:25%}
.col-xs-offset-4{margin-left:33.33333333%}
.col-xs-offset-5{margin-left:41.66666667%}
.col-xs-offset-6{margin-left:50%}
.col-xs-offset-7{margin-left:58.33333333%}
.col-xs-offset-8{margin-left:66.66666667%}
.col-xs-offset-9{margin-left:75%}
.col-xs-offset-10{margin-left:83.33333333%}
.col-xs-offset-11{margin-left:91.66666667%}
.display-flex-xs{display:-webkit-box;display:-ms-flexbox;display:flex}
.ms-row.reversed{-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse}
.ms-row,.ms-row.reversed{-webkit-box-orient:horizontal}
.ms-row{box-sizing:border-box;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:0;-ms-flex:0 1 auto;flex:0 1 auto;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-right:-.625rem;margin-left:-.625rem}
.flex-nowrap-md{flex-wrap:nowrap}
.flex-wrap{flex-wrap:wrap}
.ms-row--second{margin-left:-.5rem;margin-right:-.5rem}
.ms-row--second .col-xs,.ms-row--second .col-xs-1,.ms-row--second .col-xs-2,.ms-row--second .col-xs-3,.ms-row--second .col-xs-4,.ms-row--second .col-xs-5,.ms-row--second .col-xs-6,.ms-row--second .col-xs-7,.ms-row--second .col-xs-8,.ms-row--second .col-xs-9,.ms-row--second .col-xs-10,.ms-row--second .col-xs-11,.ms-row--second .col-xs-12,.ms-row--second .col-xs-offset-0,.ms-row--second .col-xs-offset-1,.ms-row--second .col-xs-offset-2,.ms-row--second .col-xs-offset-3,.ms-row--second .col-xs-offset-4,.ms-row--second .col-xs-offset-5,.ms-row--second .col-xs-offset-6,.ms-row--second .col-xs-offset-7,.ms-row--second .col-xs-offset-8,.ms-row--second .col-xs-offset-9,.ms-row--second .col-xs-offset-10,.ms-row--second .col-xs-offset-11,.ms-row--second .col-xs-offset-12{padding-right:.5rem;padding-left:.5rem}
.ms-row--third{margin-left:-.5rem;margin-right:-.5rem}
@media screen and (min-width:48em) and (max-width:63.9375em){.ms-row--third{margin-left:-.75rem;margin-right:-.75rem}}
.ms-row--third .col-xs,.ms-row--third .col-xs-1,.ms-row--third .col-xs-2,.ms-row--third .col-xs-3,.ms-row--third .col-xs-4,.ms-row--third .col-xs-5,.ms-row--third .col-xs-6,.ms-row--third .col-xs-7,.ms-row--third .col-xs-8,.ms-row--third .col-xs-9,.ms-row--third .col-xs-10,.ms-row--third .col-xs-11,.ms-row--third .col-xs-12,.ms-row--third .col-xs-offset-0,.ms-row--third .col-xs-offset-1,.ms-row--third .col-xs-offset-2,.ms-row--third .col-xs-offset-3,.ms-row--third .col-xs-offset-4,.ms-row--third .col-xs-offset-5,.ms-row--third .col-xs-offset-6,.ms-row--third .col-xs-offset-7,.ms-row--third .col-xs-offset-8,.ms-row--third .col-xs-offset-9,.ms-row--third .col-xs-offset-10,.ms-row--third .col-xs-offset-11,.ms-row--third .col-xs-offset-12{padding-right:.5rem;padding-left:.5rem}
@media screen and (min-width:48em) and (max-width:63.9375em){.ms-row--third .col-xs,.ms-row--third .col-xs-1,.ms-row--third .col-xs-2,.ms-row--third .col-xs-3,.ms-row--third .col-xs-4,.ms-row--third .col-xs-5,.ms-row--third .col-xs-6,.ms-row--third .col-xs-7,.ms-row--third .col-xs-8,.ms-row--third .col-xs-9,.ms-row--third .col-xs-10,.ms-row--third .col-xs-11,.ms-row--third .col-xs-12,.ms-row--third .col-xs-offset-0,.ms-row--third .col-xs-offset-1,.ms-row--third .col-xs-offset-2,.ms-row--third .col-xs-offset-3,.ms-row--third .col-xs-offset-4,.ms-row--third .col-xs-offset-5,.ms-row--third .col-xs-offset-6,.ms-row--third .col-xs-offset-7,.ms-row--third .col-xs-offset-8,.ms-row--third .col-xs-offset-9,.ms-row--third .col-xs-offset-10,.ms-row--third .col-xs-offset-11,.ms-row--third .col-xs-offset-12{padding-right:.75rem;padding-left:.75rem}}
@media screen and (min-width:48em) and (max-width:63.9375em){.ms-row--third .col-padding-sm--left{padding-left:calc(8.33333% - .75rem)}.ms-row--third .col-padding-sm--right{padding-right:calc(8.33333% - .75rem)}}
.ms-row--third .col-padding-xs{padding:0 calc(8.33333% - .5rem)}
@media screen and (min-width:48em) and (max-width:63.9375em){.ms-row--third .col-padding-xs{padding-right:.75rem;padding-left:.75rem}}
@media screen and (min-width:64em){.ms-row--third .col-padding-xs{padding-right:.5rem;padding-left:.5rem}}
.ms-row--third .col-xs--expanded-right{padding:0 calc(8.33333% - .5rem) 0 .5rem}
@media screen and (min-width:48em) and (max-width:63.9375em){.ms-row--third .col-xs--expanded-right{padding-right:.75rem;padding-left:.75rem}}
@media screen and (min-width:64em){.ms-row--third .col-xs--expanded-right{padding-right:.5rem;padding-left:.5rem}}
.ms-row--third .col-xs--expanded-left{padding:0 .5rem 0 calc(8.33333% - .5rem)}
@media screen and (min-width:48em) and (max-width:63.9375em){.ms-row--third .col-xs--expanded-left{padding-right:.75rem;padding-left:.75rem}}
@media screen and (min-width:64em){.ms-row--third .col-xs--expanded-left{padding-right:.5rem;padding-left:.5rem}}
.ms-row.collapsed{margin-left:0;margin-right:0}
.ms-row.collapsed .col-xs,.ms-row.collapsed .col-xs-1,.ms-row.collapsed .col-xs-2,.ms-row.collapsed .col-xs-3,.ms-row.collapsed .col-xs-4,.ms-row.collapsed .col-xs-5,.ms-row.collapsed .col-xs-6,.ms-row.collapsed .col-xs-7,.ms-row.collapsed .col-xs-8,.ms-row.collapsed .col-xs-9,.ms-row.collapsed .col-xs-10,.ms-row.collapsed .col-xs-11,.ms-row.collapsed .col-xs-12,.ms-row.collapsed .col-xs-offset-0,.ms-row.collapsed .col-xs-offset-1,.ms-row.collapsed .col-xs-offset-2,.ms-row.collapsed .col-xs-offset-3,.ms-row.collapsed .col-xs-offset-4,.ms-row.collapsed .col-xs-offset-5,.ms-row.collapsed .col-xs-offset-6,.ms-row.collapsed .col-xs-offset-7,.ms-row.collapsed .col-xs-offset-8,.ms-row.collapsed .col-xs-offset-9,.ms-row.collapsed .col-xs-offset-10,.ms-row.collapsed .col-xs-offset-11,.ms-row.collapsed .col-xs-offset-12{padding-right:0;padding-left:0}
.ms-row.expanded{margin-right:-.625rem;margin-left:-.625rem}
.flex-fill{flex-grow:1}
.start-xs{text-align:left;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;text-align:start}
.center-xs{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;text-align:center}
.end-xs{text-align:right;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;text-align:end}
.top-xs{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}
.middle-xs{-webkit-box-align:center;-ms-flex-align:center;align-items:center}
.bottom-xs{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}
.self-bottom-xs{-webkit-align-self:end;-ms-grid-column-align:end;align-self:flex-end}
.around-xs{-ms-flex-pack:distribute;justify-content:space-around}
.between-xs{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}
.first-xs{-webkit-box-ordinal-group:0;-ms-flex-order:-1;order:-1}
.last-xs{-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1}
@media screen and (min-width:48em){
  .col-sm,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-sm-offset-0,.col-sm-offset-1,.col-sm-offset-2,.col-sm-offset-3,.col-sm-offset-4,.col-sm-offset-5,.col-sm-offset-6,.col-sm-offset-7,.col-sm-offset-8,.col-sm-offset-9,.col-sm-offset-10,.col-sm-offset-11,.col-sm-offset-12{box-sizing:border-box;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;padding-right:.625rem;padding-left:.625rem}
  .col-sm{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-preferred-size:0;flex-basis:0;max-width:100%}
  .col-sm-1{-ms-flex-preferred-size:8.33333333%;flex-basis:8.33333333%;max-width:8.33333333%}
  .col-sm-2{-ms-flex-preferred-size:16.66666667%;flex-basis:16.66666667%;max-width:16.66666667%}
  .col-sm-3{-ms-flex-preferred-size:25%;flex-basis:25%;max-width:25%}
  .col-sm-4{-ms-flex-preferred-size:33.33333333%;flex-basis:33.33333333%;max-width:33.33333333%}
  .col-sm-5{-ms-flex-preferred-size:41.66666667%;flex-basis:41.66666667%;max-width:41.66666667%}
  .col-sm-6{-ms-flex-preferred-size:50%;flex-basis:50%;max-width:50%}
  .col-sm-7{-ms-flex-preferred-size:58.33333333%;flex-basis:58.33333333%;max-width:58.33333333%}
  .col-sm-8{-ms-flex-preferred-size:66.66666667%;flex-basis:66.66666667%;max-width:66.66666667%}
  .col-sm-9{-ms-flex-preferred-size:75%;flex-basis:75%;max-width:75%}
  .col-sm-10{-ms-flex-preferred-size:83.33333333%;flex-basis:83.33333333%;max-width:83.33333333%}
  .col-sm-11{-ms-flex-preferred-size:91.66666667%;flex-basis:91.66666667%;max-width:91.66666667%}
  .col-sm-12{-ms-flex-preferred-size:100%;flex-basis:100%;max-width:100%}
  .col-sm-offset-0{margin-left:0}
  .col-sm-offset-1{margin-left:8.33333333%}
  .col-sm-offset-2{margin-left:16.66666667%}
  .col-sm-offset-3{margin-left:25%}
  .col-sm-offset-4{margin-left:33.33333333%}
  .col-sm-offset-5{margin-left:41.66666667%}
  .col-sm-offset-6{margin-left:50%}
  .col-sm-offset-7{margin-left:58.33333333%}
  .col-sm-offset-8{margin-left:66.66666667%}
  .col-sm-offset-9{margin-left:75%}
  .col-sm-offset-10{margin-left:83.33333333%}
  .col-sm-offset-11{margin-left:91.66666667%}
  .display-flex-sm{display:-webkit-box;display:-ms-flexbox;display:flex}
  .start-sm{text-align:left;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;text-align:start}
  .center-sm{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;text-align:center}
  .end-sm{text-align:right;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;text-align:end}
  .top-sm{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}
  .middle-sm{-webkit-box-align:center;-ms-flex-align:center;align-items:center}
  .bottom-sm{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}
  .self-bottom-sm{-webkit-align-self:end;-ms-grid-column-align:end;align-self:flex-end}
  .around-sm{-ms-flex-pack:distribute;justify-content:space-around}
  .between-sm{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}
  .first-sm{-webkit-box-ordinal-group:0;-ms-flex-order:-1;order:-1}
  .last-sm{-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1}
}
@media screen and (min-width:64em){
  .col-md,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-md-offset-0,.col-md-offset-1,.col-md-offset-2,.col-md-offset-3,.col-md-offset-4,.col-md-offset-5,.col-md-offset-6,.col-md-offset-7,.col-md-offset-8,.col-md-offset-9,.col-md-offset-10,.col-md-offset-11,.col-md-offset-12{box-sizing:border-box;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;padding-right:.625rem;padding-left:.625rem}
  .col-md{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-preferred-size:0;flex-basis:0;max-width:100%}
  .col-md-1{-ms-flex-preferred-size:8.33333333%;flex-basis:8.33333333%;max-width:8.33333333%}
  .col-md-2{-ms-flex-preferred-size:16.66666667%;flex-basis:16.66666667%;max-width:16.66666667%}
  .col-md-3{-ms-flex-preferred-size:25%;flex-basis:25%;max-width:25%}
  .col-md-4{-ms-flex-preferred-size:33.33333333%;flex-basis:33.33333333%;max-width:33.33333333%}
  .col-md-5{-ms-flex-preferred-size:41.66666667%;flex-basis:41.66666667%;max-width:41.66666667%}
  .col-md-6{-ms-flex-preferred-size:50%;flex-basis:50%;max-width:50%}
  .col-md-7{-ms-flex-preferred-size:58.33333333%;flex-basis:58.33333333%;max-width:58.33333333%}
  .col-md-8{-ms-flex-preferred-size:66.66666667%;flex-basis:66.66666667%;max-width:66.66666667%}
  .col-md-9{-ms-flex-preferred-size:75%;flex-basis:75%;max-width:75%}
  .col-md-10{-ms-flex-preferred-size:83.33333333%;flex-basis:83.33333333%;max-width:83.33333333%}
  .col-md-11{-ms-flex-preferred-size:91.66666667%;flex-basis:91.66666667%;max-width:91.66666667%}
  .col-md-12{-ms-flex-preferred-size:100%;flex-basis:100%;max-width:100%}
  .col-md-offset-0{margin-left:0}
  .col-md-offset-1{margin-left:8.33333333%}
  .col-md-offset-2{margin-left:16.66666667%}
  .col-md-offset-3{margin-left:25%}
  .col-md-offset-4{margin-left:33.33333333%}
  .col-md-offset-5{margin-left:41.66666667%}
  .col-md-offset-6{margin-left:50%}
  .col-md-offset-7{margin-left:58.33333333%}
  .col-md-offset-8{margin-left:66.66666667%}
  .col-md-offset-9{margin-left:75%}
  .col-md-offset-10{margin-left:83.33333333%}
  .col-md-offset-11{margin-left:91.66666667%}
  .display-flex-md{display:-webkit-box;display:-ms-flexbox;display:flex}
  .start-md{text-align:left;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;text-align:start}
  .center-md{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;text-align:center}
  .end-md{text-align:right;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;text-align:end}
  .top-md{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}
  .middle-md{-webkit-box-align:center;-ms-flex-align:center;align-items:center}
  .bottom-md{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}
  .self-bottom-md{-webkit-align-self:end;-ms-grid-column-align:end;align-self:flex-end}
  .around-md{-ms-flex-pack:distribute;justify-content:space-around}
  .between-md{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}
  .first-md{-webkit-box-ordinal-group:0;-ms-flex-order:-1;order:-1}
  .last-md{-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1}
}
@media screen and (min-width:75em){
    .col-lg,.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-lg-offset-0,.col-lg-offset-1,.col-lg-offset-2,.col-lg-offset-3,.col-lg-offset-4,.col-lg-offset-5,.col-lg-offset-6,.col-lg-offset-7,.col-lg-offset-8,.col-lg-offset-9,.col-lg-offset-10,.col-lg-offset-11,.col-lg-offset-12{box-sizing:border-box;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;padding-right:.625rem;padding-left:.625rem}
  .col-lg{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-preferred-size:0;flex-basis:0;max-width:100%}
  .col-lg-1{-ms-flex-preferred-size:8.33333333%;flex-basis:8.33333333%;max-width:8.33333333%}
  .col-lg-2{-ms-flex-preferred-size:16.66666667%;flex-basis:16.66666667%;max-width:16.66666667%}
  .col-lg-3{-ms-flex-preferred-size:25%;flex-basis:25%;max-width:25%}
  .col-lg-4{-ms-flex-preferred-size:33.33333333%;flex-basis:33.33333333%;max-width:33.33333333%}
  .col-lg-5{-ms-flex-preferred-size:41.66666667%;flex-basis:41.66666667%;max-width:41.66666667%}
  .col-lg-6{-ms-flex-preferred-size:50%;flex-basis:50%;max-width:50%}
  .col-lg-7{-ms-flex-preferred-size:58.33333333%;flex-basis:58.33333333%;max-width:58.33333333%}
  .col-lg-8{-ms-flex-preferred-size:66.66666667%;flex-basis:66.66666667%;max-width:66.66666667%}
  .col-lg-9{-ms-flex-preferred-size:75%;flex-basis:75%;max-width:75%}
  .col-lg-10{-ms-flex-preferred-size:83.33333333%;flex-basis:83.33333333%;max-width:83.33333333%}
  .col-lg-11{-ms-flex-preferred-size:91.66666667%;flex-basis:91.66666667%;max-width:91.66666667%}
  .col-lg-12{-ms-flex-preferred-size:100%;flex-basis:100%;max-width:100%}
  .col-lg-offset-0{margin-left:0}
  .col-lg-offset-1{margin-left:8.33333333%}
  .col-lg-offset-2{margin-left:16.66666667%}
  .col-lg-offset-3{margin-left:25%}
  .col-lg-offset-4{margin-left:33.33333333%}
  .col-lg-offset-5{margin-left:41.66666667%}
  .col-lg-offset-6{margin-left:50%}
  .col-lg-offset-7{margin-left:58.33333333%}
  .col-lg-offset-8{margin-left:66.66666667%}
  .col-lg-offset-9{margin-left:75%}
  .col-lg-offset-10{margin-left:83.33333333%}
  .col-lg-offset-11{margin-left:91.66666667%}
  .display-flex-lg{display:-webkit-box;display:-ms-flexbox;display:flex}
  .start-lg{text-align:left;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;text-align:start}
  .center-lg{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;text-align:center}
  .end-lg{text-align:right;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;text-align:end}
  .top-lg{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}
  .middle-lg{-webkit-box-align:center;-ms-flex-align:center;align-items:center}
  .bottom-lg{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}
  .self-bottom-lg{-webkit-align-self:end;-ms-grid-column-align:end;align-self:flex-end}
  .around-lg{-ms-flex-pack:distribute;justify-content:space-around}
  .between-lg{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}
  .first-lg{-webkit-box-ordinal-group:0;-ms-flex-order:-1;order:-1}
  .last-lg{-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1}
}
.hide{display:none!important}
.show{display:block!important}
@media screen and (min-width:64em){.hide-for-md{display:none!important}}
@media screen and (max-width:63.9375em){.show-for-md{display:none!important}}
.text--left{text-align:left}
.text--center{text-align:center}
.layout{max-width:75rem;margin:0 auto;position:relative}
.layout--full-width{width:100%;max-width:100%}
.c-lazy-frame__vimeo,.c-lazy-frame__youtube{background-color:#fff;position:relative;padding-top:56.25%;overflow:hidden;cursor:pointer}
.c-lazy-frame__play-button{width:3.75rem;height:2.5rem;background-color:#fff;border-radius:1.375rem;z-index:1;cursor:pointer;transition:all .2s linear}
.c-lazy-frame__play-button,.c-lazy-frame__play-button:before{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}
.c-lazy-frame__play-button:before{content:"";display:block;width:0;height:0;border-color:transparent transparent transparent #000;border-style:inset inset inset solid;border-width:7px 0 7px 7px}
.c-lazy-frame__play-button:hover{background-color:#000}
.c-lazy-frame__play-button:hover:before{border-left-color:#fff}
.c-lazy-frame__image{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);cursor:pointer;width:100%;z-index: 1;}
.c-lazy-frame__image_video{z-index: 0;}
input::-ms-clear,input::-ms-reveal{display:none}
.sr-only{border:0!important;clip:rect(1px,1px,1px,1px)!important;-webkit-clip-path:inset(50%)!important;clip-path:inset(50%)!important;height:1px!important;overflow:hidden!important;padding:0!important;position:absolute!important;width:1px!important;white-space:nowrap!important}
.c-pagedesigner{color:#000}
.c-pagedesigner .pd-lazyvimeoframe-values{padding-top:unset}
.c-pagedesigner .c-background__image-container{position:absolute;top:0}
@media screen and (min-width:64em){.c-pagedesigner .c-background__image-container{position:relative}}
@media screen and (min-width:64em){.c-pagedesigner .c-background__image{position:absolute;left:50%;transform:translateX(-50%);max-width:none}}
.c-pagedesigner .c-strat__container>.experience-component:not(:last-child) .c-strat2 .has-image,.c-pagedesigner .c-strat__container>.experience-component:not(:last-child) .c-strat3 .has-image,.c-pagedesigner .c-strat__container>.experience-component:not(:last-child) .c-strat4 .has-image,.c-pagedesigner .c-strat__container>.experience-component:not(:last-child) .c-strat5 .has-image{margin-bottom:4.6875rem}
.c-pagedesigner__text-content{margin-bottom:2.1875rem}
.c-pagedesigner__title-wrapper{margin-top:1.25rem}
@media screen and (min-width:64em){.c-pagedesigner__title-wrapper{margin-top:3.125rem}}
@media screen and (min-width:75em){.c-pagedesigner__title-wrapper{margin-top:3.125rem}}
.c-pagedesigner__title{padding:0 1.0625rem}
@media screen and (min-width:48em){.c-pagedesigner__title{padding:0 3.875rem}}
@media screen and (min-width:64em){.c-pagedesigner__title{padding:0 1.875rem}}
@media screen and (min-width:75em){.c-pagedesigner__title{padding:0}}
.c-pagedesigner__title p{margin:0}
.c-pagedesigner__module-space{padding:2.5rem 1.0625rem 2.8125rem}
@media screen and (min-width:48em){.c-pagedesigner__module-space{padding:3.125rem}}
.c-pagedesigner .experience-layouts-strat3+.experience-layouts-2column .c-pagedesigner__module-space-background,.c-pagedesigner__module-space-background{margin-top:0}
.c-pagedesigner a{text-decoration:underline}
.c-pagedesigner a:hover{text-decoration:none;color:#c4926d!important}
.c-text-image{display:block;text-decoration:none}
.c-text-image–-secondary,.c-text-image–-secondary .c-text-image__visual{position:relative}
@media screen and (min-width:64em){.c-text-image–-secondary .c-text-image__visual:after{content:"";position:absolute;width:100%;height:100%;background:transparent;top:0;left:0;-webkit-transition:background .5s ease-in-out;transition:background .5s ease-in-out}
.c-text-image–-secondary .c-text-image__visual:hover:after{background:rgba(0,0,0,.4)}}
.c-text-image–-secondary .c-text-image__visual-title{font-size:1.25rem;font-family:HelveticaNeueLTW05-45Light,arial,sans-serif;color:#fff;text-align:center;line-height:1;text-decoration:none;width:100%;position:absolute;top:0;height:100%;display:flex;justify-content:center;align-items:center;flex-direction:column;z-index:1}
.c-text-image–-secondary .c-text-image__visual-title:before{content:"";width:100%;height:100%;top:0;left:0;position:absolute;z-index:1}
.c-text-image–-secondary .c-text-image__visual-title--thin{font-family:HelveticaNeueLTW05-35Thin,arial,sans-serif;line-height:1.25rem}
@media screen and (min-width:48em){.c-text-image–-secondary .c-text-image__visual-title--thin{line-height:2.5rem}}
.c-text-image–-secondary .c-text-image__visual-title--uppercase{font-size:1.875rem;font-family:HelveticaNeueLTW05-75Bold,arial,sans-serif;letter-spacing:-.05rem;display:block}
.c-text-image–-secondary .c-text-image__visual-title--secondary{font-size:1.875rem;font-family:HelveticaNeueLTW05-75Bold,arial,sans-serif;top:50%;left:50%;transform:translate(-50%,-50%);height:auto;display:inline-block}
@media screen and (min-width:48em){.c-text-image–-secondary .c-text-image__visual-title{font-size:2.5rem}.c-text-image–-secondary .c-text-image__visual-title--uppercase{font-size:3.75rem;letter-spacing:-.075rem}}
.c-text-image–-secondary .c-text-image__content{display:flex}
.c-text-image–-secondary .c-text-image__content .c-text-image__text{flex-grow:1;width:0;text-align:left}
.c-text-image–-secondary .c-text-image__description{font-size:.875rem;font-family:HelveticaNeueLTW05-45Light,arial,sans-serif;color:#575757;max-width:24.375rem;padding-top:.3125rem}
@media screen and (min-width:64em){.c-text-image–-secondary .c-text-image__description{margin-top:.625rem}}
.c-content-carousel__item{padding:0 .625rem;text-align:center}
@media screen and (min-width:48em){.c-content-carousel__item{padding:0 .75rem}}
@media screen and (min-width:64em){.c-content-carousel__item{padding:0 .5rem}}
.c-editorial-push{display:flex;justify-content:center;margin:0 0 2.1875rem;width:100%}
.c-editorial-push a{text-decoration:none;width:100%}
.c-editorial-push .c-text-image–-secondary .c-text-image__visual-title{font-size:1.25rem;font-family:HelveticaNeueLTW05-45Light,arial,sans-serif;color:#fff;text-align:center;line-height:1;text-decoration:none;display:inline-block;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);height:auto}
@media screen and (min-width:48em){.c-editorial-push .c-text-image–-secondary .c-text-image__visual-title{margin-top:0}}
.c-editorial-push .c-text-image–-secondary .c-text-image__visual-title--thin{font-size:1.25rem;line-height:2.5rem;font-family:HelveticaNeueLTW05-35Thin,arial,sans-serif}
@media screen and (min-width:48em){.c-editorial-push .c-text-image–-secondary .c-text-image__visual-title--thin{font-size:2.5rem}}
.c-editorial-push .c-text-image–-secondary .c-text-image__visual-title--uppercase{font-size:1.875rem}
@media screen and (min-width:48em){.c-editorial-push .c-text-image–-secondary .c-text-image__visual-title--uppercase{font-size:3.75rem}}
.c-editorial-push .c-text-image__visual{width:100%;overflow:hidden}
@media screen and (min-width:64em){.c-editorial-push .c-text-image__visual{height:auto}}
@media screen and (min-width:48em){.c-editorial-push{margin:0 0 5rem}}
@media screen and (min-width:64em){.c-editorial-push{margin:0 0 3.125rem}}
.c-strat1__background{bottom:0;top:unset}
@media screen and (min-width:48em) and (max-width:63.9375em){.c-strat1__background{width:100%}}
.c-strat1--col{padding:0 .5625rem}
.c-strat1--col .c-img-start1{margin-bottom:3.125rem}
@media screen and (min-width:64em){.c-strat1--col .c-img-start1{margin-bottom:0}}
.c-strat1__main-image{padding:0 2.0625rem}
@media screen and (min-width:48em){.c-strat1__main-image{padding:0 1.875rem}}
@media screen and (min-width:64em){.c-strat1__main-image{padding:0 3.8125rem}}
@media screen and (min-width:75em){.c-strat1__main-image{padding:0}}
@media screen and (min-width:48em) and (max-width:63.9375em){.c-strat1 .c-background__image{width:100%;max-width:100%}}
.c-strat1 .c-pagedesigner__title{font-family:HelveticaNeueLTW05-75Bold,arial,sans-serif;font-size:.9375rem;line-height:1.25rem;letter-spacing:.125rem;text-transform:uppercase;margin-bottom:1.875rem;padding:0}
@media screen and (min-width:48em){.c-strat1 .c-pagedesigner__title-wrapper{margin-bottom:3.125rem;margin-top:0}}
.c-strat1--rowA,.c-strat1--rowB,.c-strat1--rowC{margin-top:0}
@media screen and (min-width:64em){.c-strat1--rowA--last .c-img-start1,.c-strat1--rowB--last .c-img-start1,.c-strat1--rowC--last .c-img-start1{margin-top:3.125rem}}
.c-strat1 .row-with-template{margin-bottom:3.125rem}
@media screen and (min-width:48em){.c-strat1 .row-with-template{padding-top:0;margin-bottom:0}}
@media screen and (min-width:48em){.c-strat1 .c-background__content-wrapper{padding:4.6875rem 2.8125rem}}
@media screen and (min-width:75em){.c-strat1 .c-background__content-wrapper{padding:4.6875rem 0}}
.c-strat1.c-strat1--image{padding:4.6875rem 0}
@media screen and (min-width:64em){.c-strat1.c-strat1--image{padding:0}}
@media screen and (min-width:48em){.c-img-start1{padding:0 .125rem}}
@media screen and (min-width:64em){.c-img-start1{padding:0}}
.c-img-start1__elements{display:flex;flex-direction:column}
.c-img-start1__title-wrapper{display:flex;order:2}
.c-img-start1__imagevideo-wrapper{order:1}
.c-img-start1--title{font-family:HelveticaNeueLTW05-75Bold,arial,sans-serif;line-height:1.5rem;text-transform:none;font-size:.8125rem;margin-bottom:0}
@media screen and (min-width:48em){.c-img-start1--title{font-size:1rem}}
.c-img-start1 .wrapper-img .c-img-start1--title{margin-top:1.25rem}
.c-strat2__main-image{text-align:center;padding:4.6875rem 0}
@media screen and (min-width:48em){.c-strat2__main-image{padding:4.6875rem 1.875rem}}
@media screen and (min-width:75em){.c-strat2__main-image{padding:4.6875rem 0}}
.c-strat2__image-wrapper,.c-strat2__title-wrapper-bottom{margin-top:3.125rem}
.c-strat2__title h2{color:inherit;font-family:PlayfairDisplay-Regular,arial,sans-serif;font-size:2.5rem;line-height:2.625rem;margin-bottom:0}
@media screen and (min-width:48em){.c-strat2__title h2{font-size:4.7rem;line-height:4.25rem}}
.c-strat2__title h2:last-child{margin-bottom:1.25rem}
.c-strat2__title h2 a{font-family:PlayfairDisplay-Regular,arial,sans-serif;font-size:inherit;color:inherit}
.c-strat2__big-p{color:inherit;text-align:center}
.c-strat2__big-p p{font-family:HelveticaNeueLTW05-45Light,arial,sans-serif;font-size:1rem;line-height:1.5rem;margin-bottom:0}
@media screen and (min-width:48em){.c-strat2__big-p p{font-size:1.5625rem;line-height:2rem}}
.c-strat2__big-p p a{font-family:HelveticaNeueLTW05-45Light,arial,sans-serif;font-size:inherit;color:inherit}
.c-strat2__regular-p{color:inherit;text-align:center;margin-top:1.25rem}
.c-strat2__regular-p p{font-family:HelveticaNeueLTW05-45Light,arial,sans-serif;font-size:.8125rem;line-height:1.3125rem;margin-bottom:0}
@media screen and (min-width:48em){.c-strat2__regular-p p{font-size:1rem;line-height:1.5rem}}
.c-strat2__regular-p p a{font-family:HelveticaNeueLTW05-45Light,arial,sans-serif;font-size:inherit;color:inherit}
.c-strat3{padding:4.6875rem 1.125rem 1.5625rem}
@media screen and (min-width:48em){.c-strat3{padding:4.6875rem 2.0625rem 1.5625rem}}
@media screen and (min-width:64em){.c-strat3{padding:4.6875rem 0 1.5625rem}}
.c-strat3__title{font-size:.9375rem;line-height:1.25rem;letter-spacing:.125rem}
.c-strat3__title,.c-strat3__title a{color:inherit;font-family:HelveticaNeueLTW05-75Bold,arial,sans-serif}
.c-strat3__title a{font-size:inherit}
.c-strat3__title-wrapper{margin-bottom:3.125rem}
.c-strat3__small-p{color:inherit;text-align:center;margin-top:1.875rem}
.c-strat3__small-p p{margin-bottom:0;font-size:1rem;line-height:1.5rem}
.c-strat3__small-p p,.c-strat3__small-p p a{font-family:HelveticaNeueLTW05-45Light,arial,sans-serif}
.c-strat3__small-p p a{font-size:inherit;color:inherit}
.c-strat3__subtitle{color:inherit;margin-top:1.25rem}
.c-strat3__subtitle p{font-family:PlayfairDisplay-Regular,arial,sans-serif;font-size:2.0625rem;line-height:2.1875rem;margin-bottom:0}
@media screen and (min-width:48em){.c-strat3__subtitle p{font-size:2.25rem;line-height:2.4375rem}}
.c-strat3__subtitle p a{font-family:PlayfairDisplay-Regular,arial,sans-serif;font-size:inherit;color:inherit}
.c-strat3 .c-img-start3{margin-bottom:3.125rem}
.c-strat3 .c-img-start3__img-subtitle{margin-top:3.125rem}
.c-strat3 .c-img-start3__img-subtitle p{font-family:PlayfairDisplay-Regular,arial,sans-serif;font-size:2.25rem;line-height:2.125rem;margin-bottom:0}
@media screen and (min-width:48em){.c-strat3 .c-img-start3__img-subtitle p{font-size:2.25rem;line-height:2.4375rem}}
.c-strat3 .c-img-start3__img-subtitle p a{font-family:PlayfairDisplay-Regular,arial,sans-serif;font-size:inherit;color:inherit}
.c-strat4{padding:4.6875rem 1.0625rem}
@media screen and (min-width:48em){.c-strat4{padding:4.6875rem 2.4375rem}}
@media screen and (min-width:64em){.c-strat4{padding:4.6875rem 0}}
</style>